
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","x1":"0","y1":"0","x2":"1","y2":"1"}},[_c('stop',{attrs:{"offset":"20%","stop-color":"#FFF"}}),_c('stop',{attrs:{"offset":"75%","stop-color":"#303593"}})]),_c('circle',{attrs:{"cx":"16","cy":"16","r":"14","stroke":"url(#a)","stroke-width":"3","fill":"none"}})])
          )
        }
      }
    